import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const createZone = async (data: CreateZoneReqT) =>
  axios.post(Routes.CREATE_ZONE, data);

export const useCreateZone = () =>
  useMutation({
    mutationKey: [Keys.CREATE_ZONE_MUT],
    mutationFn: createZone,
  });
